export default __webpack_public_path__ + "static/media/abcd.0f905b5f.png";